<template>
    <ui-crud title="Operative Planning" subtitle="Manage bookings and operative registers." :fetch="fetch">

        <!-- Filters. -->
        <template #filters="{ refresh }">
            <ui-select class="mt-6" name="filter" v-model="activeFilter" :options="filterables"
                       @input="refresh()"></ui-select>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="item.date"
                :subtitle="item.getPresentAbsentArray()"
                :metadata="`${item.bookings_count} Bookings`"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ refresh }">
            <operative-planning-form :package-id="packageId" :refresh="refresh"
                                     ref="create_form"></operative-planning-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ refresh, selectedItem, setEditMode, removeItem }">
            <operative-planning-form :package-id="packageId" :item="selectedItem" :refresh="refresh"
                                     :edit="setEditMode" ref="edit_form"></operative-planning-form>
        </template>

        <!-- Show page. -->
        <template #show="{ refresh, selectedItem, setEditMode, removeItem, createNew }">
            <operative-planning-show :package-id="packageId" :item="selectedItem" :refresh="refresh"
                                     :create-item="createNew" :edit="setEditMode"
                                     :remove-item="removeItem" ref="show_form"></operative-planning-show>
        </template>
    </ui-crud>
</template>

<script>
import {OperativePlanning} from '@models'

export default {
    props: {
        packageId: null,
    },
    data() {
        const urlParams = new URLSearchParams(window.location.search);
        let filter = urlParams.get('filter');
        if (!filter) {
            filter = 'all'
        }
        return {
            activeFilter: filter,
            filterables: [
                {value: 'all', label: 'All Dates'},
                {value: 'has_bookings', label: 'Dates with Bookings'},
                {value: 'has_registers', label: 'Dates with Registers'},
                {value: 'needs_actioning', label: 'Dates needing Actioning'},
            ]
        }
    },
    methods: {
        async fetch() {
            return await OperativePlanning.all(this.packageId, this.activeFilter)
        },
    },
    mounted() {
        this.$root.$on('item-duplicated', data => {
            this.$refs.create_form.form.bookings = data.bookings;
            this.$refs.create_form.$refs.booking.mutableValue = data.bookings
        });
    }
}
</script>
